import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import AdminTaxonomies from '../../../../containers/Admin/Taxonomies';
import AdminTaxonomyEdit from '../../../../containers/Admin/TaxonomyEdit';

const SettingsTaxonomiesContent = (props) => {
  const { activeTab, activeSubTab } = props;
  const { taxonomyId } = useParams();

  if (activeTab === 'categories') {
    if (!activeSubTab && !taxonomyId) return <AdminTaxonomies />;

    if (activeSubTab === 'add' || taxonomyId) return <AdminTaxonomyEdit />;
  }

  return null;
};

SettingsTaxonomiesContent.propTypes = {
  activeTab: PropTypes.string,
  activeSubTab: PropTypes.string,
};

SettingsTaxonomiesContent.defaultProps = {
  activeTab: null,
  activeSubTab: null,
};

export default SettingsTaxonomiesContent;
